<script setup lang="ts">
import Popover from 'primevue/popover';
import { useTemplateRef } from 'vue';

const props = defineProps<DescriptionIconProps>();

const popover = useTemplateRef('popover');

function onClick(ev: Event) {
  popover.value?.toggle(ev);
}

export interface DescriptionIconProps {
  description: string;
}

</script>

<template>
  <i @click="onClick" class="pi pi-question-circle"></i>
  <Popover ref="popover">{{ props.description }}</Popover>
</template>
